import React from "react";

type ErrorModalProps = {
    open: boolean;
    message: string | any[];
    onClose: () => void;
};

const ErrorModal: React.FC<ErrorModalProps> = ({
    open,
    message,
    onClose,
}) => {
    if (!open) return null;

    const isArrayMessage = Array.isArray(message);
    const showScroll = isArrayMessage && message[0].length > 10;
    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h3 style={styles.title}>Error</h3>

                {/* ✅ Message Rendering */}
                {isArrayMessage ? (
                    <div
                        style={{
                            ...styles.messageContainer,
                            maxHeight: showScroll ? "240px" : "auto",
                            overflowY: showScroll ? "auto" : "visible",
                        }}
                    >
                        <ul style={styles.list}>
                            {message[0].map((msg: any, index: any) => (
                                <li key={index} style={styles.listItem}>
                                    {String(msg)}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p style={styles.singleMessage}>{message}</p>
                )}
                <div style={styles.buttonContainer}>
                    <button className="primary-button" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;

/* Styles (same file) */
const styles: Record<string, React.CSSProperties> = {
    overlay: {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },

    modal: {
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "8px",
        width: "420px",
        maxWidth: "90%",
        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
    },

    title: {
        marginBottom: "12px",
        color: "#333",
    },

    messageContainer: {
        marginBottom: "20px",
        padding: "10px",
        border: "1px solid #f1f1f1",
        borderRadius: "4px",
        backgroundColor: "#fafafa",
        textAlign: "left",
    },

    list: {
        paddingLeft: "18px",
        margin: 0,
    },

    listItem: {
        color: "#d32f2f",
        fontSize: "14px",
        marginBottom: "6px",
        wordBreak: "break-word",
    },

    singleMessage: {
        color: "#d32f2f",
        marginBottom: "20px",
        wordBreak: "break-word",
    },

    button: {
        padding: "8px 20px",
        backgroundColor: "#1976d2",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
    },

};